var __fast_options = __fast_options || {};
__fast_options.with_product_attributes = true;
// __fast_options.add_current_product_as_first_variant = true;

function modifyGrid(element) {
  element.querySelectorAll('.products-grid .product-card').forEach(card => {
    const gridProduct = window.loadedProducts[card.dataset.productId];
    const productTitle = gridProduct.title;
    // console.log("Product:", gridProduct);

    //add isSoldOut class to the product card
    // if(gridProduct && gridProduct.isSoldOut)
    // {
    //   card.classList.add("isSoldOut");
    // }

    // Split title and variant title
    const titleParts = productTitle.split(' - ');
    const title = titleParts[0];
    const variantTitle = titleParts[1];

    // Only variant
    const variantOnlyTitle = gridProduct.variants[0].attributes.Title;
    const variantOnlyColor = gridProduct.variants[0].attributes.Color;

    // Update card title
    card.querySelector('.fs-product-title').textContent = title;

    // Update variant title
    if (titleParts.length > 1) {
      card.querySelector('.fs-product-vendor').textContent = variantTitle;
    } else if (gridProduct.alternativeProducts === undefined && variantOnlyTitle) {
      card.querySelector('.fs-product-vendor').textContent = variantOnlyTitle;
    } else if (gridProduct.alternativeProducts === undefined && variantOnlyColor) {
      card.querySelector('.fs-product-vendor').textContent = variantOnlyColor;
    } else {
      card.querySelector('.fs-product-vendor').textContent = '';
    }

    // Replace the SKU to variant SKU
    const variantOnlySKU = gridProduct.variants[0].attributes["Product-sku"];
    const skuElement = card.querySelector('.fs-sku');
    if (skuElement && variantOnlySKU) {
      const prefixElement = skuElement.querySelector('.fs-sku-prefix');
      if (prefixElement) {
        const newSkuText = document.createTextNode(variantOnlySKU); // Create new text node for SKU
        skuElement.innerHTML = ''; // Clear existing content
        skuElement.appendChild(prefixElement);
        skuElement.appendChild(newSkuText);
      }
    }

    // isSoldOut
    try {
      const sellAble = gridProduct.variants[0].attributes["Sellable"];

      // If product is sold out, add --option-display: none; to the product card
      if (sellAble === false) {
        card.style.setProperty('--option-display', 'none');
      }
    } catch (error) {
      console.log('Error accessing isSoldOut property:', gridProduct);
    }
    
  });
}



function hooks() {
  // Hook for product grid data
  window.SerpOptions.registerHook('serp-product-grid', ({ products, element }) => {

    // Store products globally
    window.loadedProducts = products;

    modifyGrid(element);

    // Loop products using entries
    // productEntries = Object.entries(products);
    // productEntries.forEach(([productId, product]) => {
    //   console.log("Product:", productId, product);
    //   modifyGrid(element);
    // })
  });

}

// Execution
if (window.SerpOptions) {
  hooks();
} else {
  window.addEventListener('fast-serp-ready', function () {
    hooks();
  });
}

// Minicart Init
ajaxCart.init({
  cartContainer: '.minicart-container',
  cartCountSelector: '.minicart-count',
  cartCostSelector: '.minicart-cost',
  moneyFormat: theme.moneyFormat
});

// document.addEventListener('cart:refresh', function () {
//   console.log('Cart refresh event');
// });

// document.dispatchEvent(new CustomEvent("fs-custom-events-add-to-cart-response",{
//   detail: {
//       cart: t
//   }
// }));

// Implementing cart refresh
document.addEventListener('fs-custom-events-add-to-cart-response', function (event) {
  jQuery(document).trigger('afterCartLoad.buildCart', [event.detail.cart]);

  jQuery(".block-minicart").addClass("active");
  setTimeout(function () {
    jQuery(".block-minicart").removeClass("active");
  }, 3000);
});